export default __webpack_public_path__ + "static/media/07 3D (5-3).0e3477d9.jpg";